import type { MutableRefObject } from "react";

import { PdfExportService } from "app/services/PdfExportService";

const HTML_SELECTOR = "style";

export const getPNG = (
    chartRef: MutableRefObject<HTMLElement>,
    offSetX: number,
    offSetY: number,
    title: string,
): (() => Promise<void>) | undefined => {
    const styleHTML = PdfExportService.getStylesheetsForPng();
    if (chartRef !== undefined) {
        return (): Promise<void> =>
            PdfExportService.downloadHtmlPngFedService(
                styleHTML + chartRef.current.outerHTML,
                title,
                chartRef.current.offsetWidth + offSetX,
                chartRef.current.offsetHeight + offSetY,
            );
    }
};
